/**
 * @file m站 我的行程
 */
import React, {Component} from 'react';
import {NavBar, ListView, Icon} from 'antd-mobile';
import {parseStateToSearch, parseSearchToState,coloseM} from '../../util/util.js';
import NavBarComponent from '../../component/common/NavBarComponent'
import {Http, urls} from '../../api/index';
import storage from 'store';
import './routeOrderList.scss';

const orderStatus = { 0: '待支付', 1: '支付中', 8: '待取车', 9: '待取车', 10: '待取车', 50: '已取车', 60: '已还车', 100: '已取消' } // 8部分已预付 9部分已支付 10全部已支付
let tmpList = []

class RouteOrderList extends Component {
    constructor() {
        super();
        const dataSource = new ListView.DataSource({
            rowHasChanged: (row1, row2) => row1 !== row2,
        });
        this.state = {
            currentPage: 1,
            pages: 10,
            totals: 0,
            list: [],
            dataSource,
            none: '',
            isLoading: false
        };
    }

    componentDidMount() {
        this.init();
    }
    componentWillReceiveProps(props){
        this.init();
    }

    init() {
        setTimeout(() => {
            this.setState({
                currentPage: 1,
                pages: 10,
                totals: 0,
                list: [],
                dataSource: this.state.dataSource.cloneWithRows({}),
                isLoading: false
            });
            let params=parseSearchToState(window.location.search);
            if(params['car-vs']||params.APPVersion){
                storage.set('channel','fromYueChe');
                storage.set('APPVersion',params['car-vs']?params['car-vs']:params.APPVersion);
                this.FreeAccess();
            }else{
                this.getList();
            }
            
        }, 600);
    }
    FreeAccess(){
        let params=parseSearchToState(window.location.search);
        let url=urls.FreeAccess;
        Http.post({url, data: {
            customerId:params.customerid,
            token:params.token
        }}).then(res=>{
            storage.set('user', res.data)
        }).then(res=>{
            this.getList();
        })
    }
    onEndReached(_this) {
        _this.state.currentPage += 1;
        setTimeout(() => {
            _this.getList();
        }, 1000);
    }

    getList(type) {
        if (this.state.isLoading) {
            return false
        }
        this.setState({
            isLoading: true
        })
        let url = urls.myOrderList;
        let data = {
          pageNum: this.state.currentPage,
          pageSize: this.state.pages
        };
        Http.post({url, data}).then(res => {
          res.data.result && res.data.result.length > 0 && res.data.result.map(item => {
            if (item.orderStatus === 0 && item.orderPaytimeType === 1) {
              item.orderStatusText = '待取车'
            } else if (item.orderStatus === 0 || item.orderStatus === 1 ) {
              item.orderStatusText = '待支付'
            } else if (item.orderStatus === 8 || item.orderStatus === 9 || item.orderStatus === 10){
              item.orderStatusText = orderStatus[item.orderStatus]
            } else if (item.orderStatus === 50) {
              item.orderStatusText = '待还车'
            } else if (item.orderStatus === 60) {
               item.orderStatusText = item.orderSettleStatus === 0 ? '待结算' : '已完成';
            } else if (item.orderStatus === 100) {
              item.orderStatusText = '已取消'
            }
          })
          setTimeout(() => {
            this.setState({
                totals: res.data.total,
                none: res.data.total <= 0 ? '暂无订单' : '',
                list: type === 'pull' ? res.data.result : [...this.state.list, ...res.data.result || []],
                isLoading: false
              });
              // 对数据做倒序处理
              tmpList = this.state.list.length && [...this.state.list].reverse()
              this.setState({
                dataSource: this.state.dataSource.cloneWithRows(tmpList)
              })
          }, 0);
        })
    }

    goDetail(orderNo){
        const {history} = this.props
        history.push({
            pathname: '/routeOrder',
            search: parseStateToSearch({orderNo: orderNo})
        })
    }

    render() {
        let index = tmpList.length - 1;
        const row = (rowData, sectionID, rowID) => {
            if (index < 0) {
                index = tmpList.length - 1;
            }
            const item = tmpList[index--];
            return (
                <div key={rowID} className="card h-shadow" onClick={() => {this.goDetail(item.orderNo)}}>
                    <div className="title">
                        <span className="iconfont icon-time font14 c9 mr5"></span>
                        <span className="font12">{item.bookingGaincarTime.substr(0,16)}至{item.bookingBackcarTime.substr(0,16)}({item.tenancyDays}天)</span>
                    </div>
                    <div className="title mt10">
                        <span className="iconfont icon-radio font14 red mr5"></span>
                        <span className="font13">{item.bookingGaincarStoreName}</span>
                    </div>
                    <div className="fot">
                        <div className="title mt10 wid70">
                            <span className="iconfont icon-radio font14 blue mr5"></span>
                            <span className="font13">{item.bookingBackcarStoreName}</span>
                        </div>
                        <div className="more">
                            {item.orderStatus == 0 && item.orderPaytimeType === 0 ? 
                                <span className="iconfont icon-time red fs48 mr5"></span> :
                                <span style={{display: 'none'}}></span>
                            }
                            <span className="c9 font14">{item.orderStatusText}</span>
                            <span className="iconfont icon-more font14 mt3"></span>
                        </div>
                    </div>
                </div>
            );
        };
        let params=parseSearchToState(window.location.search);
        let header;
        if(params['car-vs']||params.APPVersion){
            header=(
                <NavBarComponent>
                     <NavBar  icon={<Icon type="cross" color='#333' />} 
                     onLeftClick={() => {coloseM()}} mode='light'>我的行程</NavBar>
                </NavBarComponent>
            )
        }else{ 
            header=(
            <NavBarComponent>
                <NavBar  icon={<Icon type="left" color='#333' />} 
                onLeftClick={() => {this.props.history.goBack()}} mode='light'>我的行程</NavBar>
            </NavBarComponent>
            )
        }
        return (
            <div id="routeOrderList" className="page">
                {header}
                <div className="space"></div>
                <div className="flybox">到门店取车前，请提前完成实名和驾照认证、并绑定本人信用卡，否则将无法取车，详情可咨询客服{window.LXOptions.qaMobile}</div>
                {this.state.list.length<=0 ? 
                    <div className="text-center">
                        <span>{this.state.none}</span>
                    </div> : 
                    <ListView
                        ref={el => this.lv = el}
                        dataSource={this.state.dataSource}
                        renderFooter={() => (<div style={{ padding: 3, textAlign: 'center' }}>
                        </div>)}
                        renderRow={row}
                        style={{
                            overflow: 'auto',
                            background: '#f5f5f9 !important',
                            height: 'calc(100% - 100px)'
                        }}
                        pageSize={this.state.pages}
                        scrollRenderAheadDistance={500}
                        onEndReached={() => this.onEndReached(this)}
                        onEndReachedThreshold={20}
                    />
                }
            </div>
        );
    }
}

export default RouteOrderList;
